import {lazy, Suspense} from 'react';
import {Spinner} from 'components/spinner';

const Application = lazy(() => import('pages/Application'));

const AuthenticatedContent = (props: any) => {
  return (
    <Suspense fallback={<Spinner />}>
      <Application {...props} />
    </Suspense>
  );
};

export default AuthenticatedContent;
